import { useTranslation } from "react-i18next";

interface StarterChipsProps {
  disabled?: boolean;
  canTranslate?: boolean;
  canRetranslateStale?: boolean;
  onPick?: (chipKey: string, prompt: string) => void;
}

export const StarterChips = ({
  disabled = false,
  canTranslate = false,
  canRetranslateStale = false,
  onPick,
}: StarterChipsProps) => {
  const { t } = useTranslation();

  const generateAllLabel = t("general.assistantScenarIa.chips.generateAll") as string;
  const translateLabel = t("general.assistantScenarIa.chips.translate") as string;
  const retranslateStaleLabel = t("general.assistantScenarIa.chips.retranslateStale") as string;
  const translateTitle = t("general.assistantScenarIa.chips.translateTooltip") as string;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-2">
      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          if (disabled) return;
          onPick?.("generateAll", "");
        }}
        className="text-[11px] px-3 py-1.5 rounded-md bg-green-500 text-white font-medium hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        ✨ {generateAllLabel}
      </button>
      {canTranslate && (
        <button
          type="button"
          disabled={disabled}
          title={translateTitle}
          onClick={() => {
            if (disabled) return;
            onPick?.("translate", "");
          }}
          className="text-[11px] px-3 py-1.5 rounded-md border border-green-200 text-green-600 bg-white hover:bg-green-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {translateLabel}
        </button>
      )}
      {canRetranslateStale && (
        <button
          type="button"
          disabled={disabled}
          onClick={() => {
            if (disabled) return;
            onPick?.("retranslateStale", "");
          }}
          className="text-[11px] px-3 py-1.5 rounded-md border border-amber-200 text-amber-700 bg-white hover:bg-amber-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {retranslateStaleLabel}
        </button>
      )}
    </div>
  );
};

export default StarterChips;
